const version ='1.5.2'
export default version
console.log(version)
